import { useState } from "react";
import { Calendar, Wrench, Bike } from "lucide-react";
import { toast } from "sonner";
import { apiClient } from "../lib/api";

const SERVICES = ["Periyodik Bakım", "Lastik Değişimi", "Yağ Değişimi", "Fren Bakımı", "Ekspertiz", "Genel Kontrol", "Diğer"];

const AppointmentForm = () => {
  const [form, setForm] = useState({
    name: "", phone: "", motorcycle_brand: "", motorcycle_model: "",
    service_type: SERVICES[0], appointment_date: "", appointment_time: "", notes: "",
  });
  const [sending, setSending] = useState(false);
  const onCh = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.motorcycle_brand || !form.appointment_date) {
      toast.error("Ad, telefon, marka ve tarih zorunludur.");
      return;
    }
    setSending(true);
    try {
      await apiClient.post("/appointments", form);
      toast.success("Randevu talebiniz alındı. En kısa sürede sizinle iletişime geçeceğiz.");
      setForm({ name: "", phone: "", motorcycle_brand: "", motorcycle_model: "", service_type: SERVICES[0], appointment_date: "", appointment_time: "", notes: "" });
    } catch { toast.error("Randevu oluşturulamadı. Lütfen tekrar deneyin."); }
    finally { setSending(false); }
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <div data-testid="appointment-page" className="bg-zinc-950 text-white pt-32 pb-24 min-h-screen">
      <div className="max-w-3xl mx-auto px-6">
        <div className="mb-10 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="block h-px w-8 bg-orange-500" />
            <span className="text-orange-500 font-bold uppercase tracking-[0.3em] text-xs">Servis Randevusu</span>
            <span className="block h-px w-8 bg-orange-500" />
          </div>
          <h1 className="font-display text-4xl md:text-6xl font-bold uppercase tracking-tight">
            Randevu <span className="text-orange-500">Oluştur</span>
          </h1>
          <p className="mt-4 text-zinc-400">Motorunuz için servis randevusunu birkaç tıkla planlayın.</p>
        </div>

        <form onSubmit={submit} className="bg-black border border-zinc-900 p-8 space-y-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <In label="Ad Soyad *" name="name" value={form.name} onChange={onCh} testid="apt-name" />
            <In label="Telefon *" name="phone" value={form.phone} onChange={onCh} testid="apt-phone" />
            <In label="Motor Markası *" name="motorcycle_brand" value={form.motorcycle_brand} onChange={onCh} testid="apt-brand" />
            <In label="Model" name="motorcycle_model" value={form.motorcycle_model} onChange={onCh} testid="apt-model" />
            <div>
              <label className="block text-xs uppercase tracking-widest text-zinc-500 mb-2">Hizmet Türü *</label>
              <select data-testid="apt-service" name="service_type" value={form.service_type} onChange={onCh}
                className="w-full bg-transparent border border-zinc-800 focus:border-orange-500 outline-none px-4 py-3 text-white">
                {SERVICES.map(s => <option key={s} value={s} className="bg-black">{s}</option>)}
              </select>
            </div>
            <In label="Tarih *" name="appointment_date" type="date" value={form.appointment_date} onChange={onCh} testid="apt-date" min={today} />
            <In label="Saat" name="appointment_time" type="time" value={form.appointment_time} onChange={onCh} testid="apt-time" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-zinc-500 mb-2">Notlar</label>
            <textarea data-testid="apt-notes" name="notes" value={form.notes} onChange={onCh} rows={3}
              className="w-full bg-transparent border border-zinc-800 focus:border-orange-500 outline-none px-4 py-3 text-white resize-none" />
          </div>
          <button type="submit" disabled={sending} data-testid="apt-submit"
            className="w-full inline-flex items-center justify-center gap-3 bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white px-8 py-4 font-bold uppercase tracking-widest text-sm transition-colors">
            {sending ? "Gönderiliyor..." : (<><Calendar size={16} /> Randevu Oluştur</>)}
          </button>
        </form>
      </div>
    </div>
  );
};

const In = ({ label, testid, ...rest }) => (
  <div>
    <label className="block text-xs uppercase tracking-widest text-zinc-500 mb-2">{label}</label>
    <input data-testid={testid} {...rest}
      className="w-full bg-transparent border border-zinc-800 focus:border-orange-500 outline-none px-4 py-3 text-white" />
  </div>
);

export default AppointmentForm;
